import React, { useState } from 'react';
import { Toolbar, Button, Select, MenuItem, TextField, Typography } from '@material-ui/core';
import { Preview as PreviewIcon, Publish as PublishIcon } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import '../assets/styles/ListingAd.css';

const ListingAd = () => {
  const [selectedAddress, setSelectedAddress] = useState('');
  const [selectedRoom, setSelectedRoom] = useState('');
  const [selectedCaption, setSelectedCaption] = useState('');

  const handleAddressChange = (event) => {
    setSelectedAddress(event.target.value);
  };

  const handleRoomSelect = (room) => {
    setSelectedRoom(room);
  };

  const handleCaptionChange = (event) => {
    setSelectedCaption(event.target.value);
  };

  const renderImages = () => {
    // Map each room to a set of placeholder images
    switch (selectedRoom) {
      case 'Living Room':
        return (
          <>
            <div className="listing-ad-image"></div>
            <div className="listing-ad-image"></div>
            <div className="listing-ad-image"></div>
          </>
        );
      case 'Bedroom':
        return (
          <>
            <div className="listing-ad-image"></div>
            <div className="listing-ad-image"></div>
          </>
        );
      case 'Bathroom':
        return (
          <>
            <div className="listing-ad-image"></div>
          </>
        );
      case 'Kitchen':
        return (
          <>
            <div className="listing-ad-image"></div>
            <div className="listing-ad-image"></div>
            <div className="listing-ad-image"></div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Typography variant="h4" align="center" style={{ marginBottom: '16px' }}>
        Listing Ad
      </Typography>
      <Toolbar>
        <Button variant="contained" color="secondary" component={Link} to="/preview">
          Preview
        </Button>
        <div style={{ flex: 1 }}></div>
        <Button variant="contained" color="primary">
          Auto Generate
        </Button>
        <Button variant="contained" color="secondary">
          Publish
        </Button>
      </Toolbar>
      <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'center' }}>
        <Select
          value={selectedAddress}
          onChange={handleAddressChange}
          displayEmpty
          variant="outlined"
          style={{ width: '240px' }}
        >
          <MenuItem value="" disabled>
            Select Address
          </MenuItem>
          <MenuItem value="123 Main St">123 Main St</MenuItem>
          <MenuItem value="456 Elm St">456 Elm St</MenuItem>
          <MenuItem value="789 Oak St">789 Oak St</MenuItem>
        </Select>
      </div>
      <div style={{ marginTop: '16px' }}>
        <h3>Select Images</h3>
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '16px' }}>
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: '16px' }}
            onClick={() => handleRoomSelect('Living Room')}
          >
            Living Room
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: '16px' }}
            onClick={() => handleRoomSelect('Bedroom')}
          >
            Bedroom
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: '16px' }}
            onClick={() => handleRoomSelect('Bathroom')}
          >
            Bathroom
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: '16px' }}
            onClick={() => handleRoomSelect('Kitchen')}
          >
            Kitchen
          </Button>
          {/* Add more room buttons here */}
        </div>
        <div className="listing-ad-container">{renderImages()}</div>
        <div style={{ marginTop: '16px' }}>
          <h3>Select Caption</h3>
          <div style={{ display: 'flex', marginBottom: '16px' }}>
            <TextField
              label="Caption A"
              variant="outlined"
              fullWidth
              value={selectedCaption}
              onChange={handleCaptionChange}
              style={{ marginRight: '8px' }}
            />
            <TextField
              label="Caption B"
              variant="outlined"
              fullWidth
              value={selectedCaption}
              onChange={handleCaptionChange}
              style={{ marginRight: '8px' }}
            />
            <TextField
              label="Caption C"
              variant="outlined"
              fullWidth
              value={selectedCaption}
              onChange={handleCaptionChange}
              style={{ marginRight: '8px' }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ListingAd;
